// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 23 23\"><g stroke-width=3><path d=\"M11 1.656v20.041M21.344 12H1.303\"/></g></svg> ";
// Exports
module.exports = code;